<template>
  <div class="page-view">
    <div class="scroll-view-wrapper exercise-question-detail">
      <e-header title="问题讨论" :showBtn="false" />

      <div class="detail-info">
        <p class="title">{{ detailInfo.subject }}</p>
        <div class="user-info">
          <img class="avatar" :src="detailInfo.userAvatar" alt="" />
          <div class="info">
            <p class="name">{{ detailInfo.userName }}</p>
            <p class="hospital">{{ detailInfo.hospitalName }}</p>
          </div>
        </div>
        <p class="content">{{ detailInfo.detail.description }}</p>
        <p class="imgs">
          <img
            v-for="(item, index) in detailInfo.detail.files"
            @click.stop="showPopupImage(detailInfo.imageList, index)"
            :key="index"
            :src="item"
          />
        </p>
        <p class="time">{{ detailInfo.createdDate }}</p>
      </div>

      <div class="all-comments" ref="allCommentsRef">
        <p class="title">全部讨论 {{ totalCommentCount }}</p>
        <div class="content">
          <template v-if="!commentList.length">
            <no-comment />
          </template>
          <template v-else>
            <comment
              v-for="item in commentList"
              :key="item.remarkId"
              :comment="item"
              @reply="reply"
              @like="like"
              @showAll="showAll(item)"
            />
          </template>
        </div>
      </div>

      <div class="pageview-fixed">
        <div class="pageview-fixed-wrapper" @click.stop="replyQuestion">
          <span class="input">我要留言</span>
          <span class="btn">发布</span>
        </div>
        <div class="ui-safe-area-inset"></div>
      </div>
    </div>
    <!-- 回复 -->
    <comment-modal
      :placeholder="placeholder"
      :visible="commentModalVisible"
      :replyType="replyType"
      :id="replyId"
      :userId="replyUserId"
      :showMask="showReplyMask"
      @close="showCommentModal(false)"
      @send-success="replySuccess"
    />
    <!-- 所有评论回复 -->
    <all-comment-modal
      :visible="allCommentModalVisible"
      :remarkId="showAllComment.remarkId"
      :refresh="allCommentRefresh"
      @refresh="changeAllCommentRefresh(false)"
      @close="showAllCommentModal(false)"
      @reply="reply"
    />
  </div>
</template>

<script setup>
import {
  onMounted,
  ref,
  getCurrentInstance,
  onBeforeUnmount,
  nextTick
} from 'vue'
import utils from '@/public/utils'
import { exerReq } from '@/api'

import EHeader from '@/components/exercise/header/index.vue'
import NoComment from '@/components/exercise/question/no-comment.vue'
import CommentModal from '@/components/exercise/question/comment-modal.vue'
import Comment from '@/components/exercise/question/comment.vue'
import AllCommentModal from '@/components/exercise/question/all-comment.vue'

import cloneDeep from 'lodash/cloneDeep'
import lodashFindIndex from 'lodash/findIndex'
import lodashFind from 'lodash/find'
import { jumpModuleApp } from '@/widget/index'
// 图片预览
import { ImagePreview } from 'vant'
const {
  proxy: { $showLoading, $hideLoading, $toast }
} = getCurrentInstance()

const id = ref(utils.getQueryParams('id') || 0)
const type = ref(utils.getQueryParams('type') || 0)
const commentList = ref([])
const totalCommentCount = ref(0)
const allCommentsRef = ref(null)

const detailInfo = ref({
  detail: {
    files: []
  }
})
const getDetail = async () => {
  if (!id.value) {
    $toast('id不存在')
    return
  }
  $showLoading()
  const res = await exerReq.getQuestionDetail({
    dialogId: id.value
  })
  $hideLoading()
  if (Number(res.code) === 200) {
    const data = res.data
    data.imageList = data.detail.files.map((item, index) => {
      return {
        image: item,
        id: index + 1
      }
    })
    detailInfo.value = data

    commentList.value = res.data.remarks
    totalCommentCount.value = res.data.remarkCount
    nextTick(() => {
      if (type.value) {
        const dom = allCommentsRef.value
        document.scrollingElement.scrollTop = dom.offsetTop
      }
    })
  } else {
    $toast(res.message)
  }
}

// const getRemarkList = async () => {
//   $showLoading()
//   const res = await exerReq.getDialogRemarkList({
//     dialogId: id.value
//   })
//   $hideLoading()
//   if (Number(res.code) === 200) {
//     commentList.value = commentList.value.concat(res.data.remarks)
//     totalCommentCount.value = res.data.totalCount
//   } else {
//     $toast(res.message)
//   }
// }

const commentModalVisible = ref(false)
const showCommentModal = val => {
  commentModalVisible.value = val
}

const replySuccess = type => {
  showCommentModal(false)
  if (type === 0) {
    getDetail()
  } else if (type === 1) {
    changeAllCommentRefresh(true)
    getDetail()
  }
}

const allCommentModalVisible = ref(false)
const showAllCommentModal = val => {
  allCommentModalVisible.value = val
}
const allCommentRefresh = ref(false)
const changeAllCommentRefresh = value => {
  allCommentRefresh.value = value
}
const showAllComment = ref({})
const showAll = item => {
  showAllComment.value = item
  showAllCommentModal(true)
}

const placeholder = ref('')
const replyType = ref(0)
const replyId = ref(0)
const replyUserId = ref(0)
const showReplyMask = ref(true)

const replyQuestion = () => {
  replyType.value = 0
  replyId.value = detailInfo.value.dialogId
  placeholder.value = `我要留言，最多100字`
  showCommentModal(true)
}

const reply = value => {
  replyUserId.value = value.userId
  showReplyMask.value = value.showReplyMask
  placeholder.value = `回复${value.userName}：`
  replyType.value = value.replyType
  if (value.replyType === 1) {
    replyId.value = value.remarkId
  } else if (value.replyType === 2) {
    replyId.value = value.messageId
  }
  showCommentModal(true)
}

const like = item => {
  const data = cloneDeep(commentList.value)
  let n = item.approved ? -1 : 1
  let bl = !item.approved
  if (lodashFindIndex(data, item) > -1) {
    let temp = lodashFindIndex(data, item)
    data[temp].approvalCount += n
    data[temp].approved = bl
  } else {
    let tempData = lodashFind(data, { remarkId: item.remarkId })
    let ind = lodashFindIndex(data, { remarkId: item.remarkId })
    let num = lodashFindIndex(tempData.messages, item)
    if (num > -1) {
      tempData.messages[num].approvalCount += n
      tempData.messages[num].approved = bl
    }
    data[ind] = cloneDeep(tempData)
  }
  commentList.value = data
}
// 图片预览
const showPopupImage = (list, index) => {
  let images = list.map(item => item.image)
  if (utils.isApp()) {
    jumpModuleApp({ typeId: 'image_preview', images: images, posIndex: index })
  } else {
    ImagePreview({
      images: images,
      closeable: true,
      startPosition: index
    })
  }
}

const pageNo = ref(1)
const timer = ref(null)
const isScrollLoad = ref(false)
const scrollTop = ref(0)
// const showLoading = ref(false)
const scrollLoadList = () => {
  const winHeight = window.innerHeight
  scrollTop.value = document.scrollingElement.scrollTop
  const scrollViewHeight =
    document.querySelector('.scroll-view-wrapper').offsetHeight - 20
  const realFunc = () => {
    if (
      winHeight + scrollTop.value >= scrollViewHeight &&
      commentList.value.length < totalCommentCount.value
    ) {
      pageNo.value += 1
      // this.showLoading = true
      // this.getArticleList()
    } else {
      // this.isScrollLoad = true
      isScrollLoad.value = true
    }
  }
  if (isScrollLoad.value) {
    isScrollLoad.value = false
    timer.value = window.requestAnimationFrame(realFunc)
  }
}

onMounted(() => {
  getDetail()
  window.addEventListener(
    'scroll',
    scrollLoadList,
    utils.isPassive() ? { passive: true, capture: true } : true
  )
})

onBeforeUnmount(() => {
  window.cancelAnimationFrame(timer.value)
  window.removeEventListener(
    'scroll',
    scrollLoadList,
    utils.isPassive() ? { passive: true, capture: true } : true
  )
})
</script>
<style lang="scss" scoped>
@import '~@/components/exercise/style/default.scss';

.exercise-question-detail {
  background-color: #f5f5f7;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .detail-info {
    flex-shrink: 0;
    padding: 32px;
    background-color: #fff;
    .title {
      color: #212224;
      font-size: 36px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .user-info {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .avatar {
        width: 68px;
        height: 68px;
        border-radius: 50%;
        margin-right: 16px;
        background-color: black;
      }
      .info {
        .name {
          color: #212224;
          font-size: 28px;
        }
        .hospital {
          color: #969799;
          font-size: 24px;
        }
      }
    }

    .content {
      color: #626366;
      line-height: 48px;
      font-size: 32px;
      margin-bottom: 16px;
    }

    .imgs {
      display: flex;
      margin-bottom: 10px;
      img {
        display: block;
        width: 212px;
        height: 212px;
        border-radius: 8px;
        margin-right: 24px;
        pointer-events: auto;
        &:last-child {
          margin-right: 0;
        }
      }
    }

    .time {
      font-size: 24px;
      color: #9a9a9a;
    }
  }

  .all-comments {
    padding: 30px 0 150px;
    background-color: #fff;
    margin-top: 16px;
    flex: 1;
    .title {
      padding: 0 30px;
      color: #212224;
      font-size: 32px;
      font-weight: bold;
    }
  }

  .pageview-fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

    &-wrapper {
      box-shadow: 0px 0px 16px 0px rgba(181, 184, 189, 0.2);
      height: 100px;
      display: flex;
      align-items: center;
      padding: 0 28px;
      background-color: #fff;
      .input {
        flex: 1;
        background-color: #f5f5f5;
        border-radius: 34px;
        height: 68px;
        line-height: 68px;
        margin-right: 20px;
        font-size: 28px;
        color: #9a9a9a;
        padding-left: 26px;
      }
      .btn {
        flex-shrink: 0;
        display: inline-block;
        width: 112px;
        height: 68px;
        line-height: 68px;
        text-align: center;
        background-color: rgba(255, 102, 0, 0.5);
        border-radius: 34px;
        font-size: 28px;
        color: #fff;
      }
    }
  }
}
</style>
